import { useCallback, useEffect, useState } from 'react'

import { ICONS } from '@/components/icons/icons'

import { AuthShell } from './AuthShell'
import styles from './AuthShell.module.css'
import { beginLogin, clearSignInReason, readSignInReason } from './identityAuth'

/**
 * Sign-in, standardized with LOS, POS and Academy: the RBI brand panel and a single Microsoft SSO
 * action (Entra through identity's Hosted UI). The button follows Microsoft's sign-in branding: the
 * four-square logo on the left, Segoe UI, white on light and #2F2F2F on dark.
 */
export function LoginScreen() {
  const [reason] = useState(readSignInReason)
  const [pending, setPending] = useState(false)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    document.title = 'Sign in · RBI FP&A'
    clearSignInReason()
  }, [])

  const handleSignIn = useCallback(() => {
    setPending(true)
    setFailed(false)
    beginLogin().catch(() => {
      setPending(false)
      setFailed(true)
    })
  }, [])

  return (
    <AuthShell title="Sign in">
      <p className={styles.text}>Access is restricted to RBI Private Lending accounts.</p>
      {reason === 'SESSION_EXPIRED' ? (
        <div className={styles.alert} role="status">
          <ICONS.clock size={15} className={styles.alertIcon} />
          <span>Your session expired. Sign in again to pick up where you left off.</span>
        </div>
      ) : null}
      {failed ? (
        <div className={`${styles.alert} ${styles.alertBad}`} role="alert">
          <ICONS.alert size={15} className={styles.alertIcon} />
          <span>We could not reach the sign-in service. Try again in a moment.</span>
        </div>
      ) : null}
      <button type="button" className={styles.msButton} onClick={handleSignIn} disabled={pending} aria-busy={pending}>
        <ICONS.microsoft size={21} className={styles.msLogo} />
        <span>{pending ? 'Redirecting to Microsoft…' : 'Sign in with Microsoft'}</span>
      </button>
      <p className={styles.hint}>You&rsquo;ll be redirected to your company sign-in.</p>
    </AuthShell>
  )
}
